import { useState } from 'react';
import { Switch } from '@/components/forms/Switch';
import type { TraderSurveillanceProfileDto } from '@/api/types/traderSurveillance';

interface ProfileListProps {
  title: string;
  items: TraderSurveillanceProfileDto[];
  loading: boolean;
  variant: 'active' | 'deleted';
  defaultOpen?: boolean;
  onView: (id: string) => void;
  onEdit?: (id: string) => void;
  onDelete?: (row: TraderSurveillanceProfileDto) => void;
  onToggle?: (row: TraderSurveillanceProfileDto) => void;
}

export function ProfileList({ title, items, loading, variant, defaultOpen, onView, onDelete, onToggle }: ProfileListProps) {
  const [open, setOpen] = useState(defaultOpen ?? variant === 'active');
  return (
    <div className="card custom-card mb-2">
      <div
        className={`card-header p-2 d-flex align-items-center justify-content-between${open ? ' fk-accordion-open' : ''}`}
        role="button"
        onClick={() => setOpen((o) => !o)}
      >
        <div className="card-title mb-0">
          {title} ({items.length})
        </div>
        <i className={`fe ${open ? 'fe-chevron-up' : 'fe-chevron-down'}`} />
      </div>
      {open && (
        <div className="card-body p-2">
          {loading ? (
            <div className="text-center text-muted py-2">
              <i className="fa fa-spinner fa-spin me-1" />
              Loading…
            </div>
          ) : items.length === 0 ? (
            <div className="text-center text-muted py-2 fs-13">No profiles.</div>
          ) : (
            items.map((p) => (
              <div key={p.id} className="d-flex align-items-center justify-content-between py-1 border-bottom">
                <span className="d-inline-flex align-items-center text-truncate">
                  {variant === 'active' && (
                    <span
                      className={`rounded-circle d-inline-block me-2 ${p.enabled ? 'bg-primary' : 'bg-gray'}`}
                      style={{ width: 8, height: 8 }}
                    />
                  )}
                  <span className="fs-13 fw-semibold text-truncate">{p.profileTag}</span>
                </span>
                <span className="d-inline-flex align-items-center gap-1">
                  {variant === 'deleted' ? (
                    <button type="button" className="btn btn-sm btn-outline-info" title="View" onClick={() => onView(p.id)}>
                      <i className="fa fa-eye" />
                    </button>
                  ) : (
                    <>
                      <button type="button" className="btn btn-sm btn-outline-info" title="View" onClick={() => onView(p.id)}>
                        <i className="fa fa-eye" />
                      </button>
                      <button type="button" className="btn btn-sm btn-outline-danger" title="Delete" onClick={() => onDelete?.(p)}>
                        <i className="fa fa-trash" />
                      </button>
                      <Switch checked={p.enabled} onChange={() => onToggle?.(p)} />
                    </>
                  )}
                </span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
